export enum TcsHeaders {
  Authorization = 'x-tcs-authorization',
}
